import $ from "jquery"

class GeneralHelper {
	constructor() {
		this._initEvents()
	}

	_initEvents = () => {
		$("body")
			.on("click", ".bb-print-page", (event) => {
				event.preventDefault()
				window.print()
			})
			.on("click", ".bb-history-back", (event) => {
				event.preventDefault()
				history.back()
			})
			.on("click", ".bb-scroll-top-with-focus", (event) => {
				event.preventDefault()
				this._scrollTop(true)
			})
			.on("click", ".bb-scroll-top", (event) => {
				event.preventDefault()
				this._scrollTop()
			})
			.on("click", ".bb-copy-current-href", (event) => {
				event.preventDefault()
				navigator.clipboard.writeText(event.currentTarget.href).then(() => {})
			})
	}

	/**
	 * scrollTop with focus
	 * @param withFocus to focus first element
	 */
	_scrollTop(withFocus) {
		if (withFocus) {
			this._scrollTo(0, () => {
				let focusable = document.querySelectorAll(
					'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
				)
				focusable[0].focus()
			})
		} else {
			this._scrollTo()
		}
	}

	/**
	 * scrollTo with callback
	 * @param offset to scroll to
	 * @param callback function
	 */
	_scrollTo(offset = 0, callback = () => {}) {
		const fixedOffset = offset.toFixed()
		const onScroll = () => {
			if (window.pageYOffset.toFixed() === fixedOffset) {
				window.removeEventListener("scroll", onScroll)
				callback()
			}
		}

		window.addEventListener("scroll", onScroll)
		onScroll()
		window.scrollTo({
			top: offset,
			behavior: "smooth",
		})
	}
}

export default GeneralHelper
